module.exports = __webpack_public_path__ + "static/img/clients_shengyuan.d540c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/clients_shengyuan.png
// module id = PiBE
// module chunks = 2